import { Tooltip } from 'antd'
import { FC, ReactNode } from 'react'

interface ValidationTooltipProps {
    message?: ReactNode
    editing?: boolean
    children: ReactNode
}

export const ValidationTooltip: FC<ValidationTooltipProps> = ({
    message,
    editing = false,
    children,
}) => {
    if (!message || editing) {
        return <>{children}</>
    }

    return (
        <Tooltip title={message} placement="top">
            {children}
        </Tooltip>
    )
}

